import React from 'react';
import styles from'./Account.module.scss';
import ClinicDetails from "../../../components/ClinicDetails/ClinicDetails";
import LoginsManager from "../../../components/LoginsManager/LoginsManager";
import TreatmentSettings from "../../../components/TreatmentSettings/TreatmentSettings";
import AccountDetails from "../../../components/AccountDetails/AccountDetails";
import AccountUsersTable from "../../../components/AccountUsersTable/AccountUsersTable";

class Account extends React.Component {
    render() {
        return (
            <div>
                <div className={styles['flex-row']}>
                    <div className={styles['col']}>
                        <div className={styles['box']}>
                            <AccountDetails />
                        </div>
                        <div className={styles['box']}>
                            <ClinicDetails userType={3} className={styles['box']}/>
                        </div>
                        {/*<div className={styles['box']}>*/}
                        {/*    <AssignmentRequests userType={3} />*/}
                        {/*</div>*/}
                    </div>
                    <div className={styles['col']}>
                        <div className={styles['box']}>
                            <TreatmentSettings userType={3} className={styles['box']}/>
                        </div>
                        <div className={styles['box']}>
                            <LoginsManager className={styles['box']}/>
                        </div>
                    </div>
                </div>
                <div className={styles['flex-row']}>
                    <div className={styles['box']}>
                        <AccountUsersTable/>
                    </div>
                </div>
            </div>
        );
    }
}

export default Account;
